import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';

import { useNotification } from '../Contexts/NotificationContext';
import ContentSlides from './ContentSlides';
import ImagesList from './ImagesList';

const SearchResults = () => {
    const { setNotification } = useNotification();
    const [content, setContent] = useState({});
    const [loading, setLoading] = useState(true);

    const accessToken = localStorage.getItem('access_token');
    const baseUrl = process.env.REACT_APP_API_URL;

    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const tipo = queryParams.get('tipo');
    const formato = queryParams.get('formato');
    const q = queryParams.get('q');

    useEffect(() => {
        const fetchSearchResults = async () => {
            setLoading(true);
            try {
                const params = new URLSearchParams();

                if (tipo) params.append('tipo', tipo);
                if (formato) params.append('formato', formato);
                if (q) params.append('q', q);

                const response = await fetch(`${baseUrl}/painel/filtros/pesquisar?${params.toString()}`, {
                    method: 'GET',
                    headers: {
                        Authorization: `Bearer ${accessToken}`,
                    },
                });

                if (response.ok) {
                    const data = await response.json();
                    setContent(data);
                } else {
                    throw new Error('Erro ao buscar os resultados da pesquisa');
                }
            } catch (error) {
                setNotification({
                    type: 'error',
                    message: error.message,
                    show: true,
                });
            } finally {
                setLoading(false);
            }
        };

        fetchSearchResults();
    }, [q, tipo, formato, accessToken, baseUrl]);

    return (
        <>
            {loading ? (
                <div className="grid grid-cols-2 md:grid-cols-4 gap-6 xl:gap-10 opacity-20">
                    {[...Array(8)].map((_, index) => (
                        <div
                            key={index}
                            role="status"
                            className="flex items-center justify-center h-0 pb-[103%] max-w-sm bg-gray-300 rounded-lg animate-pulse dark:bg-gray-700"
                        >
                            <span className="sr-only">Loading...</span>
                        </div>
                    ))}
                </div>
            ) : (
                <>
                    {content.produtos && (
                        <ContentSlides
                            content={content.produtos}
                            isCarousel={true}
                            url="/painel/produtos/"
                            title="Produtos"
                            small={true}
                            loading={loading}
                        />
                    )}
                    {content.grupos?.length > 0 &&
                        content.grupos.map((grupo) => (
                            <div key={grupo.id}>
                                {grupo.tipo === 'imagem' && (
                                    <ImagesList
                                        content={grupo.imagens}
                                        isCarousel={true}
                                        title={grupo.nome}
                                        small={true}
                                        loading={loading}
                                    />
                                )}
                                {grupo.tipo === 'video' && (
                                    <ContentSlides
                                        content={grupo.videos}
                                        isCarousel={true}
                                        url={`painel/produtos/videos/${grupo.slug}`}
                                        title={grupo.nome}
                                        small={true}
                                        loading={loading}
                                    />
                                )}
                                {grupo.tipo === 'material' && (
                                    <ContentSlides
                                        content={grupo.materiais}
                                        isCarousel={true}
                                        url={`painel/produtos/materiais/${grupo.slug}`}
                                        title={grupo.nome}
                                        small={true}
                                        loading={loading}
                                    />
                                )}
                            </div>
                        ))}
                </>
            )}
        </>
    );
};

export default SearchResults;
